

export const LightTheme = {
  color: {
    // COLORS
    white: {
      _default: "#ffffff",
      alpha: {
        _default: "rgba(255,255,255, 0.5)",
      }
    },
    black: {
      _default: "#0b0b0d",
      alpha: {
        _default: "rgba(11,11,13, 0.5)",
      }
    },
    gray: {
      _default: "#8e8e93",
      alpha: {
        _default: "rgba(142,142,147,0.5)",
      }
    },
    red: {
      _default: "#ff3b30",
      alpha: {
        _default: "rgba(255,59,48, 0.15)",
      }
    },
    orange: {
      _default: "#ff9500",
      alpha: {
        _default: "rgba(255,149,0,0.15)",
      }
    },
    yellow: {
      _default: "#ffcc00",
      alpha: {
        _default: "rgba(255,204,0,0.15)",
      }
    },
    green: {
      _default: "#34c759",
      alpha: {
        _default: "rgba(52,199,89,0.15)",
      }
    },
    mint: {
      _default: "#00c7be",
      alpha: {
        _default: "rgba(0,199,190,0.15)",
      }
    },
    teal: {
      _default: "#30b0c7",
      alpha: {
        _default: "rgba(48,176,199,0.15)",
      }
    },
    cyan: {
      _default: "#32ade6",
      alpha: {
        _default: "rgba(50,173,230,0.15)",
      }
    },
    blue: {
      _default: "#007aff",
      alpha: {
        _default: "rgba(0,122,255,0.15)",
      }
    },
    indigo: {
      _default: "#5856d6",
      alpha: {
        _default: "rgba(88,86,214,0.15)",
      }
    },
    purple: {
      _default: "#af52de",
      alpha: {
        _default: "rgba(175,82,222,0.15)",
      }
    },
    pink: {
      _default: "#ff375f",
      alpha: {
        _default: "rgba(255,55,95,0.15)",
      }
    },
    brown: {
      _default: "#a2845e",
      alpha: {
        _default: "rgba(162,132,94,0.15)",
      }
    },
//       _default: "#8e8e93",
//       2: "#aeaeb2",
//       3: "#c7c7cc",
//       4: "#d1d1d6",
//       5: "#e5e5ea",
//       6: "#f2f2f7",
    // FILL
    fill: {
      _default: {
        _default: "#f7f8fa",
        alpha: {
          _default: "rgba(142,142,147,0.5)",
        }
      },
      2: {
        _default: "#edeef2",
        alpha: {
          _default: "rgba(174,174,178,0.5)",
        }
      },
      3: {
        _default: "#d1d1d6",
        alpha: {
          _default: "rgba(209,209,214,0.5)",
        }
      },
      4: {
        _default: "#d1d1d6",
        alpha: {
          _default: "rgba(209,209,214,0.5)",
        }
      },
    },
    // TEXT
    text: {
      _default: "rgba(11,11,13, 1)",
      2: "rgba(11,11,13, 0.6)",
      3: "rgba(11,11,13, 0.3)",
      4: "rgba(11,11,13, 0.18)",
    },
    textReverse: {
      _default: "rgba(235, 235, 245, 1)",
      2: "rgba(235, 235, 245, 0.6)",
      3: "rgba(235, 235, 245, 0.3)",
      4: "rgba(235, 235, 245, 0.18)",
    },
    scrollbar: {
      _default: "#6d6d72"
    },
    border: {
      _default: "#d1d1d6",
      reverse: "#f7f8fa"
    },
    panel: {
      _default: "var(--colorFill)",
    },
    accent: {
      _default: "#9bb4ff"
    }
  },
} as const
